import React, { useState } from "react";
import { Box, Divider, Tab, Tabs, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import PurchaseTable from "./PurchaseTable";
import PurchasePaymentTable from "./PurchasePaymentTable";
import SaleTable from "./SaleTable";
import BalancePaymentTable from "./BalancePaymentTable";
import DebtorTable from "./DebtorTable";
import ReturnTable from "./ReturnTable";
import PurchaseReturnTable from "./PurchaseReturnTable";
import PayrollsTable from "./PayrollsTable";
import AdvanceTable from "./AdvanceTable";
import ExpensesTable from "./ExpensesTable";
import ComprehensivePurchaseReport from "./ComprehensivePurchaseReport";
import ComprehensiveSaleReport from "./ComprehensiveSaleReport";
import SalesDataTable from "./SalesDataTable";
import AccountGeneralReport from "./AccountGeneralReport";
import StockTransferReport from "./StockTransferReport";
import CashFlowReport from "./CashFlowReport";

const ReportsIndex = () => {
  const { t } = useTranslation();

  // Tabs
  const [value, setValue] = useState(1);
  const [selectedBranch, setSelectedBranch] = useState("");
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      {/* Header */}
      <Box sx={{ p: { xs: 2, md: 3 } }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "stretch", sm: "center" },
            mb: 2,
            gap: 0,
          }}
        >
          <Box>
            <Typography variant="h4">{t("ReportIndex.pageTitle")}</Typography>
            <Typography variant="subtitle1" color="textSecondary">
              {t("payroll.dataLoadedOn")} {new Date().toLocaleString()}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Divider />

      {/* Tabs */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          width: "100%",
          px: 2,
        }}
      >
        <Box
          sx={{
            maxWidth: { xs: 370, sm: 600, md: 900, lg: 1200 },
            width: "100%",
          }}
        >
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons
            allowScrollButtonsMobile
            aria-label="scrollable force tabs example"
            textColor="secondary"
            indicatorColor="secondary"
          >
            <Tab value={0} label={t("Purchase Report (All)")} />
            <Tab value={1} label={t("Sale Report (All)")} />
            <Tab value={3} label={t("ReportIndex.purchase")} />
            <Tab value={4} label={t("ReportIndex.purchasePayments")} />
            <Tab value={5} label={t("ReportIndex.sale")} />
            <Tab value={7} label={t("ReportIndex.balancePayments")} />
            <Tab value={16} label={t("ReportIndex.debtors", "Debtors")} />
            <Tab value={8} label={t("ReportIndex.returnSale")} />
            <Tab value={9} label={t("ReportIndex.returnPurchase")} />
            <Tab value={10} label={t("ReportIndex.payroll")} />
            <Tab value={11} label={t("ReportIndex.advance")} />
            <Tab value={12} label={t("ReportIndex.expenses")} />
            <Tab value={13} label={t("ReportIndex.accountGeneral")} />
            <Tab value={14} label="Stock Transfer" />
            <Tab value={15} label="Cash Flow" />
            {/* <Tab value={11} label="Purchase Report" /> */}
          </Tabs>
        </Box>
      </Box>

      <Divider />

      {/* Data Tables */}
      <Box p={2}>
        <Box mb={4}>
          {value === 0 && <ComprehensivePurchaseReport selectedBranch={selectedBranch} />}
          {value === 1 && (
            <ComprehensiveSaleReport
              selectedBranch={selectedBranch}
              setSelectedBranch={setSelectedBranch}
            />
          )}
          {value === 2 && <SalesDataTable />}
          {value === 3 && <PurchaseTable />}
          {value === 4 && <PurchasePaymentTable />}
          {value === 5 && <SaleTable />}
          {value === 7 && <BalancePaymentTable />}
          {value === 16 && <DebtorTable selectedBranch={selectedBranch} />}
          {value === 8 && <ReturnTable />}
          {value === 9 && <PurchaseReturnTable />}
          {value === 10 && <PayrollsTable />}
          {value === 11 && <AdvanceTable />}
          {value === 12 && <ExpensesTable />}
          {value === 13 && <AccountGeneralReport />}
          {value === 14 && <StockTransferReport />}
          {value === 15 && <CashFlowReport />}
          {/* {value === 11 && <ComprehensivePurchaseReport />} */}
        </Box>
      </Box>
    </>
  );
};

export default ReportsIndex;
